<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/punchout/shared/punchout-transfer-basket/punchout-transfer-basket.component.ts
-->
<ng-template #anchor></ng-template>
